import { apiClient } from "./client";

export type IcsInfo = {
  enabled: boolean;
  url: string | null;
  unavailabilities_url: string | null;
};

export async function getIcsInfo(): Promise<IcsInfo> {
  const { data } = await apiClient.get<IcsInfo>("/api/v1/me/ics");
  return data;
}

export async function rotateIcsToken(): Promise<IcsInfo> {
  const { data } = await apiClient.post<IcsInfo>("/api/v1/me/ics/rotate");
  return data;
}

export async function revokeIcsToken(): Promise<void> {
  await apiClient.delete("/api/v1/me/ics");
}
